/* Kocktail — header chrome (all viewports).
   Scrolling DOWN slides the header bar away once you reach the editorial
   "Kocktail started with one Negroni" section; scrolling UP — or moving the
   pointer to the top of the window — brings it back.

   Robustness:
   - Progress is derived from the trigger section's OWN getBoundingClientRect()
     (viewport-relative), so it works no matter which element actually scrolls
     (window OR an inner container). No dependency on window.scrollY.
   - It moves the element that is ACTUALLY pinned (nearest sticky/fixed ancestor
     of #header-component) by animating its sticky `top` offset. NEVER by
     transform: the mobile menu drawer is position:fixed INSIDE this wrapper,
     and a transform (or will-change: transform) on it — even translateY(0) —
     makes the wrapper the drawer's containing block. The drawer then anchors
     to the header bar instead of the viewport, and on iOS (where touch
     scrolling ignores the scroll-lock) it rides away with the page.
   - A continuous rAF loop drives it, so it never relies on scroll events firing.

   */
(function () {
  function header() { return document.getElementById('header-component'); }

  var lastProg = null;
  var hidden = false;
  var pointerNearTop = false;
  var REVEAL_ZONE = 90;
  var stickyEl = null;
  var scEl = null;

  // This theme locks html/body at overflow:hidden and scrolls an inner
  // container (.page-wrapper). So window.scrollY is always 0 — we must read
  // scroll from the real scrolling element. Find it once (prefer .page-wrapper,
  // else the first overflow scroller, else the document).
  function scrollContainer() {
    if (scEl && scEl.isConnected) return scEl;
    var pw = document.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 20) { scEl = pw; return scEl; }
    var nodes = document.querySelectorAll('body *');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i], s = getComputedStyle(el);
      if ((s.overflowY === 'auto' || s.overflowY === 'scroll') &&
          el.scrollHeight > el.clientHeight + 50) { scEl = el; return scEl; }
    }
    scEl = document.scrollingElement || document.documentElement;
    return scEl;
  }

  // Nearest ancestor of the header (or the header itself) that is pinned.
  function findStickyEl() {
    var h = header();
    if (!h) return null;
    var node = h;
    for (var i = 0; i < 6 && node && node !== document.body; i++) {
      var pos = getComputedStyle(node).position;
      if (pos === 'sticky' || pos === 'fixed') return node;
      node = node.parentElement;
    }
    return h;
  }

  // { prog, reached }. `prog` increases as you scroll DOWN. `reached` = the
  // trigger section has arrived under the header.
  function metrics() {
    var h = header();
    var headH = h ? h.offsetHeight : 60;
    var edito = document.querySelector('.kx-edito');
    if (edito) {
      var t = edito.getBoundingClientRect().top;
      return { prog: -t, reached: t <= headH + 2, ref: t, headH: headH, src: 'edito' };
    }
    var hero = document.querySelector('.kx-hero');
    if (hero) {
      var b = hero.getBoundingClientRect().bottom;
      return { prog: -b, reached: b <= headH + 2, ref: b, headH: headH, src: 'hero' };
    }
    // Inner pages (PDP/PLP, etc.): read scroll from the real scroll container,
    // and hide once scrolled a bit past the header.
    var top = scrollContainer().scrollTop || 0;
    return { prog: top, reached: top > headH + 40, ref: top, headH: headH, src: 'container' };
  }

  function drawerOpen() {
    var h = header();
    if (h && h.querySelector('dialog[open]')) return true;
    // The mobile nav is a <details class="menu-drawer-container"> that gets
    // [open]; the cart drawer is a <dialog> outside the header.
    return !!document.querySelector('details.menu-drawer-container[open], .theme-drawer__dialog[open]');
  }

  // Slide the wrapper by animating its sticky `top` offset (stylesheet value
  // is -1px). The mobile menu drawer and its backdrop are position:fixed
  // INSIDE this wrapper, and any transform or will-change:transform on it —
  // even translateY(0) — would make the wrapper their containing block,
  // re-anchoring the drawer to the header bar instead of the viewport. `top`
  // moves a stuck element the same way without ever creating one, so the
  // drawer stays viewport-fixed at every moment, mid-animation included.
  function applyHidden(v) {
    if (v === hidden) return;
    hidden = v;
    var el = stickyEl || (stickyEl = findStickyEl());
    if (!el) return;
    el.style.transition = 'top 0.34s cubic-bezier(0.22, 0.61, 0.36, 1)';
    if (v) {
      el.style.setProperty('top', '-' + (el.offsetHeight + 24) + 'px', 'important');
    } else {
      el.style.removeProperty('top');
    }
    el.style.pointerEvents = v ? 'none' : '';
    var h = header();
    if (h) h.classList.toggle('kx-header-hidden', v);
  }

  // Hiding needs 24px of SUSTAINED downward travel, not any 2px tick: iOS
  // rubber-banding, toolbar collapse and tap-to-stop-momentum all produce
  // small downward jitter, and an instant hide on those yanks the header away
  // just as the user reaches for the menu button. Revealing stays eager.
  var downTravel = 0;
  function update() {
    var h = header();
    if (!h) return;
    if (!stickyEl || !stickyEl.isConnected) stickyEl = findStickyEl();

    var m = metrics();

    if (pointerNearTop || drawerOpen()) {
      applyHidden(false);
      downTravel = 0;
      lastProg = m.prog;
      return;
    }

    if (lastProg !== null) {
      var d = m.prog - lastProg;
      if (d > 300 || d < -300) {
        // A jump this size is a layout shift, anchor nav or scroll
        // restoration, not a scroll gesture — don't let it flip the header.
        downTravel = 0;
      } else if (d > 0) {
        downTravel += d;
        if (downTravel > 24 && m.reached) applyHidden(true);
      } else if (d < -2) {
        downTravel = 0;
        applyHidden(false);
      }
    }
    if (!m.reached) applyHidden(false);
    lastProg = m.prog;
  }

  // Idle-parking loop: the old version ran unconditionally at 60fps forever,
  // reading layout every frame even with nothing moving. Behaviour is delta-
  // based (it compares this frame's progress to the last), so a parked loop
  // resuming just sees a delta on its first frame — nothing is lost.
  var running = false;
  var idleFrames = 0;
  var lastSeen = null;
  function loop() {
    update();
    var m = header() ? metrics() : null;
    var key = m ? (Math.round(m.prog) + ':' + pointerNearTop) : null;
    if (key === lastSeen) { idleFrames++; } else { idleFrames = 0; lastSeen = key; }
    if (idleFrames > 45) { running = false; return; }
    requestAnimationFrame(loop);
  }
  function kick() {
    if (running) return;
    running = true;
    requestAnimationFrame(loop);
  }

  /* ---- In-page scroll links --------------------------------------------
     A [data-kx-scroll] link moves down the page instead of navigating.
     Value is either "next" — the section after the one the link is in — or a
     selector for a specific one.

     scrollIntoView, not window.scrollTo: this theme can lock html/body at
     overflow:hidden and scroll an inner container instead, so window scroll
     coordinates are not always the page's. scrollIntoView asks the browser to
     move whichever ancestor actually scrolls, which is right either way.

     The header offset is handled by scroll-margin-top in kocktail-foundations
     rather than arithmetic here, so a plain anchor jump — no script, or a
     pasted #link — lands in the same place as a scripted one. This keeps that
     margin in step with the header's real height. */
  function syncScrollOffset() {
    var h = header();
    var box = h && (h.closest('.header-section') || h);
    var px = box ? Math.round(box.getBoundingClientRect().height) : 0;
    if (px > 0) document.documentElement.style.setProperty('--kx-scroll-offset', px + 16 + 'px');
  }

  function scrollTarget(link) {
    var val = link.getAttribute('data-kx-scroll');
    if (!val) return null;
    if (val === 'next') {
      var own = link.closest('[id^="shopify-section-"]');
      return own ? own.nextElementSibling : null;
    }
    try { return document.querySelector(val); } catch (e) { return null; }
  }

  function onScrollLinkClick(e) {
    var link = e.target && e.target.closest && e.target.closest('[data-kx-scroll]');
    if (!link) return;
    var target = scrollTarget(link);
    // No target found: leave the click alone rather than swallowing it, so a
    // real href still does something.
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    syncScrollOffset();
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }

  function init() {
    stickyEl = findStickyEl();
    update();
    kick();

    syncScrollOffset();
    window.addEventListener('load', syncScrollOffset);
    window.addEventListener('resize', syncScrollOffset);
    document.addEventListener('click', onScrollLinkClick);

    ['scroll', 'wheel', 'touchmove'].forEach(function (ev) {
      window.addEventListener(ev, kick, { passive: true, capture: true });
    });
    // Drawers open on click/keyboard; wake so drawerOpen() is re-read.
    document.addEventListener('click', kick, true);
    document.addEventListener('keydown', kick, true);
    window.addEventListener('mousemove', function (e) {
      var near = e.clientY <= REVEAL_ZONE;
      if (near !== pointerNearTop) { pointerNearTop = near; kick(); }
    }, { passive: true });
    window.addEventListener('resize', function () { stickyEl = findStickyEl(); kick(); });
    document.addEventListener('shopify:section:load', function () { stickyEl = null; hidden = false; kick(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
